/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 备份恢复模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月24日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//备份记录列表
	list(params = {}) {
		return Ajax.get('/backup', params)
	},
	//开始备份
	create(p) {
		return Ajax.post('/backup/create', p || {})
	},
	//恢复备份
	restore(id) {
		return Ajax.post(`/backup/restore/${id}`)
	},
	//上传本地备份（支持 .sql 和 .zip 格式）
	upload(params) {
		return Ajax.post('/backup/upload', params, {'Content-Type': 'multipart/form-data'})
	},
	//删除备份
	del(id) {
		return Ajax.delete(`/backup/${id}`)
	},
	//备份文件下载地址
	downloadUrl(id) {
		return `/api/backup/download/${id}`;
	},
	//获取自动备份配置
	getAutoConfig() {
		return Ajax.get('/backup/auto-config');
	},
	//保存自动备份配置
	saveAutoConfig(params) {
		return Ajax.post('/backup/auto-config', params);
	},
	//电子档案列表
	archiveList(params = {}) {
		return Ajax.get('/backup/archive', params);
	},
	//上传电子档案
	archiveUpload(params) {
		return Ajax.post('/backup/archive', params, {'Content-Type': 'multipart/form-data'});
	},
	//账套归档
	filing() {
		return Ajax.post('/backup/filing', {});
	},
	//电子档案下载地址
	archiveDownloadUrl(id) {
		return `/api/backup/archive/download/${id}`;
	},
	//删除电子档案
	archiveDel(id) {
		return Ajax.delete(`/backup/archive/${id}`);
	}
};
